import { ElementHTML } from '@helpers/helper.rendering'
import useQueryDevelopment from '@hooks/useQueryDevelopment'
import useQueryDevelopments from '@hooks/useQueryDevelopments'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React, { useState, useEffect } from 'react'
import { Container, Col, Row } from 'react-bootstrap'
import { Development, DevelopmentMediacore, RealEstateDataPageComponentData } from 'types'

interface ExternalProps {
  developmentID: string
  propertyID: string
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps

const DevelopmentsSimilar1 = ({
  title,
  titleElement,
  titleHexa,
  global_data,
  developmentID,
  backgroundColor,
}: CombinedProps) => {
  const { data: allDevelopmentsData, isLoading } = useQueryDevelopments(
    global_data.pageConfig.keys.tokko,
  )

  const {
    data: allData,
    isLoading: isLoadingDev,
    isError,
  } = useQueryDevelopment(developmentID, global_data.pageConfig.keys.tokko)

  const devCard = global_data.content?.cardsDevelopments?.type_id ?? '1'
  const Card = require(`@components/cardsDevelopments/${devCard}`)?.default

  const getSimilarDevelopments = () => {
    if (!allData?.id) {
      return []
    }
    let devs: any = allDevelopmentsData?.filter((dev) => dev?.id != allData?.id)
    const byLocation = devs?.filter(
      (dev: Development) => dev.location.name == allData.location.name,
    )
    const ranking = calcularRankingCoincidencias(
      allData,
      devs?.filter((dev: Development) => dev.location.name != allData?.location?.name),
      'id',
    )
    return [...byLocation, ...ranking]
  }

  function calcularRankingCoincidencias(
    emprendimiento: Development,
    emprendimientos: Development[] | DevelopmentMediacore[] | undefined,
    key: string,
  ) {
    if (!emprendimiento.tags || !emprendimientos?.length) {
      return []
    }

    // Crear un Set con los valores de la clave de los tags del emprendimiento base.
    const baseTagsSet = new Set(emprendimiento.tags.map((tag: any) => tag[key]))

    // Calcular coincidencias y porcentaje para cada emprendimiento.
    const resultados = emprendimientos.map((otroEmprendimiento) => {
      if (!otroEmprendimiento.tags) {
        return { ...otroEmprendimiento, porcentajeCoincidencia: 0 }
      }

      const coincidencias = otroEmprendimiento.tags.filter((tag: any) =>
        baseTagsSet.has(tag[key]),
      ).length
      const porcentaje = (coincidencias / emprendimiento.tags.length) * 100

      return {
        ...otroEmprendimiento,
        porcentajeCoincidencia: porcentaje.toFixed(2), // Redondear a 2 decimales
      }
    })

    // Ordenar por porcentaje de coincidencia descendente.
    //@ts-ignore
    resultados.sort((a, b) => b.porcentajeCoincidencia - a.porcentajeCoincidencia)

    return resultados
  }

  return (
    <section
      className="p-y-config section-similar-development"
      style={{ background: backgroundColor }}
    >
      <Container fluid>
        <ElementHTML
          children={title || 'Proyectos similares'}
          elementType={titleElement || 'h2'}
          className="mb-4 lb-lg-5"
          style={{ color: titleHexa || '#1f1f1f' }}
        />
        <Row>
          {isLoading
            ? 'Cargando...'
            : getSimilarDevelopments()
                ?.slice(0, 4)
                .map((dev: Development, index: number) => (
                  <Col
                    key={index}
                    lg={3}
                  >
                    <Card
                      development={dev}
                      global_data={global_data}
                    />
                  </Col>
                ))}
        </Row>
      </Container>
    </section>
  )
}

export default DevelopmentsSimilar1
